import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/lcsigns/signs';

export default new class LcSignsModel {

    constructor() { }

    get(id) {
        return new Promise((resolve, reject) => {
            this.getAll()
                .then((data) => {
                    resolve(_.find(data, { id: id }));
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getAll() {
        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    ParkinglocationModel.getAll(true)
                        .then((pl) => {
                            let data = [];
                            response.data.map(async (child, idx) => {
                                let location = _.find(pl, { id: child.corelocationId });
                                location
                                    ? data.push(Object.assign({}, child, { parkingLocationName: location.Code + ' - ' + location.Name }))
                                    : data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                            });
                            resolve(data);
                        });

                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    create(data) {
        return new Promise((resolve, reject) => {
            axios.post(BASE, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    remove(serialnumber) {
        return new Promise((resolve, reject) => {
            axios.delete(BASE + '/' + serialnumber, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    patch(serialNumber) {
        return new Promise((resolve, reject) => {
            axios.patch(BASE + '/' + serialNumber, null, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    turnOff(serialNumber) {
        return new Promise((resolve, reject) => {
            axios.patch(BASE + '/' + serialNumber + '/turnOff', null, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    ping(serialNumber) {
        return new Promise((resolve, reject) => {
            axios.get(BASE + '/' + serialNumber + '/ping', {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    update(serialNumber, data) {
        delete data.lastMqttStamp;
        delete data.lastSendStamp;
        if (data.id !== undefined) {
            delete data.id;
        }
        return new Promise((resolve, reject) => {
            axios.patch(BASE + '/' + serialNumber, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }



}


// WEBPACK FOOTER //
// ./src/components/LcSignsModel.js